/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelTractor.ts                       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/asset/tractor";

export class AutogenModelTractor<RowType extends ModelRow> extends Endpoint<RowType, RowTractorFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowTractor extends ModelRow<RowTractorFields> {
	constructor(values?: Partial<RowTractorFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowTractorFields {
	a_maint_hub: number;
	ace_id: string;
	allow_relay: string;
	assign_date: Date;
	avail_date: Date;
	axle_number_code: string;
	b_maint_hub: number;
	city_id: number;
	comments: string;
	company_id: string;
	current_hub: number;
	current_site: string;
	current_stop_id: string;
	currenteqpgrpid: string;
	daily_dist_goal: number;
	daily_rev_goal: number;
	daily_rev_goal_c: string;
	daily_rev_goal_d: Date;
	daily_rev_goal_n: number;
	daily_rev_goal_r: number;
	dash_hub_delta: number;
	dispatch_opt: string;
	dispatcher: string;
	dispatcher_login: string;
	dot_number: string;
	"driver.ace_id": string;
	"driver.address": string;
	"driver.alert": string;
	"driver.allow_trailer_drop": string;
	"driver.avl_as_of_date": Date;
	"driver.avl_drive_hours": number;
	"driver.avl_hours": number;
	"driver.avl_onduty_hours": number;
	"driver.base_term1": string;
	"driver.base_term2": string;
	"driver.base_zip1": string;
	"driver.base_zip2": string;
	"driver.birth_date": Date;
	"driver.bseg": string;
	"driver.can_rehire": string;
	"driver.capcreat_filter": string;
	"driver.cb": string;
	"driver.cell_phone": string;
	"driver.chain_pref_1": string;
	"driver.chain_pref_1_value": number;
	"driver.chain_pref_2": string;
	"driver.chain_pref_2_value": number;
	"driver.choice_allocation": string;
	"driver.choice_commodity": string;
	"driver.choice_commodity_exclude": string;
	"driver.choice_customer": string;
	"driver.choice_equip_type": string;
	"driver.choice_exclude_hazmat": string;
	"driver.choice_order_type": string;
	"driver.choice_priority1": string;
	"driver.choice_priority1_value": number;
	"driver.choice_priority2": string;
	"driver.choice_priority2_value": number;
	"driver.choice_revenue": string;
	"driver.choice_review_dt": Date;
	"driver.citizen": string;
	"driver.citizen_country": string;
	"driver.city": string;
	"driver.city_id": number;
	"driver.cmove": string;
	"driver.company_id": string;
	"driver.country_hos_rules": string;
	"driver.country_id": string;
	"driver.currenteqpgrpid": string;
	"driver.ded_rqmt_type": string;
	"driver.ded_type": string;
	"driver.disable_driver_choice": string;
	"driver.disable_feasibility": string;
	"driver.disable_remote_access": string;
	"driver.doubles_certified": string;
	"driver.dri_uid": number;
	"driver.drvr_class": string;
	"driver.ds_model_flag": string;
	"driver.eld_exempt_reason_id": string;
	"driver.email": string;
	"driver.emrg_response_date": Date;
	"driver.enable_driver_app": string;
	"driver.enable_load_choice": string;
	"driver.end_status_date": Date;
	"driver.enginedata_pwd": string;
	"driver.equipment_type_id": string;
	"driver.event_date": Date;
	"driver.event_status": string;
	"driver.exclude_allocation": string;
	"driver.exclude_commodity": string;
	"driver.exclude_customer": string;
	"driver.exclude_equip_type": string;
	"driver.exclude_feasibility": string;
	"driver.exclude_order_type": string;
	"driver.exclude_revenue": string;
	"driver.experience": string;
	"driver.first_name": string;
	"driver.fleet_manager": string;
	"driver.fmcsa_clearinghouse_date": Date;
	"driver.group_id": string;
	"driver.hazmat_certified": string;
	"driver.hazmat_date": Date;
	"driver.hire_date": Date;
	"driver.hm126c_date": Date;
	"driver.home_duration": number;
	"driver.home_location_id": string;
	"driver.id": string;
	"driver.is_active": string;
	"driver.last_34_hour_start_date": Date;
	"driver.last_break_date": Date;
	"driver.last_home_date": Date;
	"driver.last_review_date": Date;
	"driver.latitude": number;
	"driver.license_country": string;
	"driver.license_date": Date;
	"driver.license_no": string;
	"driver.license_state": string;
	"driver.logbook_required": string;
	"driver.longitude": number;
	"driver.manual_pta_update": string;
	"driver.maryland_perm_date": Date;
	"driver.max_dispatches": number;
	"driver.max_dist_loc1": number;
	"driver.max_dist_loc2": number;
	"driver.max_mi_per_day": number;
	"driver.mc_login": string;
	"driver.mc_unit_password": string;
	"driver.medical_cert_exempt": string;
	"driver.medical_cert_expire": Date;
	"driver.model_flag": string;
	"driver.mpw_driver_contact_method": string;
	"driver.mpw_driver_high": number;
	"driver.mpw_driver_low": number;
	"driver.mpw_exclude": string;
	"driver.mpw_last_contact": Date;
	"driver.mpw_num_attempts": number;
	"driver.mpw_num_orders": number;
	"driver.mvr_date": Date;
	"driver.name": string;
	"driver.name_mid_initial": string;
	"driver.name_of_spouse": string;
	"driver.next_home_date": Date;
	"driver.num_complaints": number;
	"driver.pager": string;
	"driver.passport": string;
	"driver.payee_id": string;
	"driver.personal_conveyance": string;
	"driver.phone": string;
	"driver.physical_date": Date;
	"driver.planning_comment": string;
	"driver.preferred_days_out": number;
	"driver.prev_code": string;
	"driver.primary_agency": string;
	"driver.proximity_card": string;
	"driver.pta_date": Date;
	"driver.race": string;
	"driver.reason_for_leaving": string;
	"driver.record_pta": string;
	"driver.remark": string;
	"driver.reporting_status": string;
	"driver.return_home_flag": string;
	"driver.route_through_term": string;
	"driver.safety_meet_date": Date;
	"driver.safety_topic": string;
	"driver.security_date": Date;
	"driver.sex": string;
	"driver.shuttle_capable": string;
	"driver.site_id": string;
	"driver.social_security_no": string;
	"driver.speed": number;
	"driver.start_status_date": Date;
	"driver.state": string;
	"driver.status_code": string;
	"driver.stop_pta_update": string;
	"driver.tanks_endorsement": string;
	"driver.team_status": string;
	"driver.tenstreet_id": string;
	"driver.termination_date": Date;
	"driver.tractor_id": string;
	"driver.trainee": string;
	"driver.type_of": string;
	"driver.violation_comment": string;
	"driver.yard_move": string;
	"driver.zip": string;
	driver1_assigned_by_info: string;
	driver1_id: string;
	driver1_terminal_descr: string;
	driver1_terminal_id: string;
	driver2_id: string;
	"driver_item.company_id": string;
	"driver_item.equipment_group_id": string;
	"driver_item.equipment_id": string;
	"driver_item.equipment_type_id": string;
	"driver_item.id": string;
	"driver_item.trailer_dropped": string;
	"driver_item.type_sequence": number;
	"equipment_group.company_id": string;
	"equipment_group.currentmovement_id": string;
	"equipment_group.id": string;
	exclude_from_trip_mgt: string;
	exclude_fuel_fueltax: string;
	exclude_fueltax: string;
	fill_hub: number;
	fleet_id: string;
	floor_space: number;
	force_assign: string;
	fuel_capacity: number;
	fuel_level: number;
	fuel_type_code: string;
	gross_veh_weight: number;
	gross_veh_weight_um: string;
	h_insurance_amount: number;
	h_insurance_amount_c: string;
	h_insurance_amount_d: Date;
	h_insurance_amount_n: number;
	h_insurance_amount_r: number;
	h_insurance_date: Date;
	home_location_id: string;
	hub_change: number;
	hub_change_date: Date;
	hub_new: number;
	hub_required: string;
	id: string;
	inservice_date: Date;
	inspection_date: Date;
	insurance_account: string;
	insurance_amount: number;
	insurance_amount_c: string;
	insurance_amount_d: Date;
	insurance_amount_n: number;
	insurance_amount_r: number;
	insurance_date: Date;
	insurance_name: string;
	irp_code: string;
	is_local: string;
	liability_end_dt: Date;
	liability_insured: string;
	liability_start_dt: Date;
	loadboard: string;
	loc_uid: number;
	maintenance_date: Date;
	make: string;
	model: string;
	model_year: string;
	"movement.authorized": string;
	"movement.average_broker_rating": number;
	"movement.booking_no": string;
	"movement.br_details_link": string;
	"movement.br_status_link": string;
	"movement.br_track_interval": number;
	"movement.br_track_status": string;
	"movement.br_track_status_desc": string;
	"movement.br_track_vehicle_id": string;
	"movement.br_tracking_id": string;
	"movement.br_vendor": string;
	"movement.broker_avail_tract": string;
	"movement.brokerage": string;
	"movement.brokerage_status": string;
	"movement.carrier_contact": string;
	"movement.carrier_email": string;
	"movement.carrier_empty_from_city_id": number;
	"movement.carrier_fuel_pay_rate_id": number;
	"movement.carrier_lane_rate_id": string;
	"movement.carrier_override_carrier": string;
	"movement.carrier_override_user": string;
	"movement.carrier_phone": string;
	"movement.carrier_rate_id": number;
	"movement.carrier_tractor": string;
	"movement.carrier_trailer": string;
	"movement.carrier_trailer_type": string;
	"movement.chassis": string;
	"movement.checkcall_sched_id": string;
	"movement.company_id": string;
	"movement.container": string;
	"movement.container_returned": string;
	"movement.container_status": string;
	"movement.controlling_carrier_code": string;
	"movement.dedicated_order_id": string;
	"movement.dest_stop_id": string;
	"movement.digital_booking": string;
	"movement.dispatcher_user_id": string;
	"movement.eform_rate_confirmation": string;
	"movement.empty2next_order": string;
	"movement.equipment_group_id": string;
	"movement.est_tolls": number;
	"movement.est_tolls_c": string;
	"movement.est_tolls_d": Date;
	"movement.est_tolls_n": number;
	"movement.est_tolls_r": number;
	"movement.exclude_movement": string;
	"movement.fleet_manager": string;
	"movement.freight_matching_override": string;
	"movement.fuel_distance": number;
	"movement.fuel_distance_um": string;
	"movement.fuel_tax_exempt": string;
	"movement.hubtran_approved_inv_date": Date;
	"movement.hubtran_ok2pay_date": Date;
	"movement.ic_company_to": string;
	"movement.ic_order_to": string;
	"movement.id": string;
	"movement.integrated_carrier_search": string;
	"movement.invoice_recv_date": Date;
	"movement.is_container": string;
	"movement.is_dray": string;
	"movement.is_intercompany": string;
	"movement.is_local_mile": string;
	"movement.linked_id": number;
	"movement.linked_sequence": number;
	"movement.load_booking_eligible": string;
	"movement.load_booking_source": string;
	"movement.loaded": string;
	"movement.locked_user_id": string;
	"movement.ltl": string;
	"movement.ltl_staging_wrs_uid": number;
	"movement.macropoint_status": string;
	"movement.manifest_empty_distance": number;
	"movement.manifest_estimated_arrival": Date;
	"movement.manifest_estimated_depart": Date;
	"movement.manifest_id": string;
	"movement.manifest_loaded_distance": number;
	"movement.manifest_reg_uid": number;
	"movement.manifest_spots_capacity": number;
	"movement.manifest_spots_consumed": number;
	"movement.manifest_weight_capacity": number;
	"movement.manifest_weight_consumed": number;
	"movement.max_buy": number;
	"movement.max_buy_c": string;
	"movement.max_buy_d": Date;
	"movement.max_buy_n": number;
	"movement.max_buy_r": number;
	"movement.max_pay_method": string;
	"movement.max_pay_units": number;
	"movement.missed_call_sent": string;
	"movement.move_distance": number;
	"movement.move_distance_um": string;
	"movement.movement_type": string;
	"movement.must_respond_by": Date;
	"movement.next_sched_call": Date;
	"movement.operational_status": string;
	"movement.operations_user": string;
	"movement.origin_stop_id": string;
	"movement.override_crny_type": string;
	"movement.override_driver2_id": number;
	"movement.override_driver2_nm": string;
	"movement.override_driver_id": number;
	"movement.override_driver_nm": string;
	"movement.override_drvr2_cell": string;
	"movement.override_drvr2_email": string;
	"movement.override_drvr_cell": string;
	"movement.override_drvr_email": string;
	"movement.override_max_pay": number;
	"movement.override_max_pay_c": string;
	"movement.override_max_pay_d": Date;
	"movement.override_max_pay_n": number;
	"movement.override_max_pay_r": number;
	"movement.override_pay_amt": number;
	"movement.override_pay_amt_c": string;
	"movement.override_pay_amt_d": Date;
	"movement.override_pay_amt_n": number;
	"movement.override_pay_amt_r": number;
	"movement.override_pay_rate": number;
	"movement.override_paye_rate": number;
	"movement.override_payee_id": string;
	"movement.override_targetpay": number;
	"movement.override_targetpay_c": string;
	"movement.override_targetpay_d": Date;
	"movement.override_targetpay_n": number;
	"movement.override_targetpay_r": number;
	"movement.override_type": string;
	"movement.override_unit_desc": string;
	"movement.override_units": number;
	"movement.pay_distance": number;
	"movement.pay_distance_um": string;
	"movement.pending_carrier_name": string;
	"movement.pending_carrier_nbr": string;
	"movement.pending_carrier_type": string;
	"movement.pending_payee_id": string;
	"movement.placard_required": string;
	"movement.preassign_sequence": number;
	"movement.priority": string;
	"movement.pro_nbr": string;
	"movement.rate_alert_basis": string;
	"movement.rate_alert_date": Date;
	"movement.rate_alert_days": number;
	"movement.rate_alert_hours": number;
	"movement.rate_alert_minutes": number;
	"movement.rate_confirm_template": number;
	"movement.rate_confirmation_sent_date": Date;
	"movement.rate_confirmation_status": string;
	"movement.rate_expiration_basis": string;
	"movement.rate_expiration_date": Date;
	"movement.rate_expiration_days": number;
	"movement.rate_expiration_hours": number;
	"movement.rate_expiration_minutes": number;
	"movement.rdy_pickup_date": Date;
	"movement.recurring_movement_id": string;
	"movement.reminder_sent": string;
	"movement.require_tracking": string;
	"movement.required_vendor": string;
	"movement.reserved": string;
	"movement.return_date": Date;
	"movement.seg_alloc_code": string;
	"movement.shipper_email": string;
	"movement.shipper_notify_frequency": string;
	"movement.shpmt_ident_type": string;
	"movement.shpmt_ident_value": string;
	"movement.ss_location_id": string;
	"movement.status": string;
	"movement.target_extra_stop_pay": number;
	"movement.target_extra_stop_pay_c": string;
	"movement.target_extra_stop_pay_d": Date;
	"movement.target_extra_stop_pay_n": number;
	"movement.target_extra_stop_pay_r": number;
	"movement.target_fuel_surcharge_pay": string;
	"movement.target_pay": number;
	"movement.target_pay_c": string;
	"movement.target_pay_d": Date;
	"movement.target_pay_method": string;
	"movement.target_pay_n": number;
	"movement.target_pay_r": number;
	"movement.target_pay_units": number;
	"movement.target_rate_data": string;
	"movement.target_rate_id": number;
	"movement.time_to_send_msg": Date;
	"movement.track_start_date": Date;
	"movement.tracking_duration_ext": number;
	"movement.tracking_notify_email": string;
	"movement.tracking_request_status": string;
	"movement.trailer_rent_pct": number;
	"movement.trip_lease": string;
	"movement.trip_mgt_recalc_datetime": Date;
	"movement.trip_mgt_tracking_id": string;
	"movement.triumphpay_exclude": string;
	"movement.trp_uid": number;
	"movement.ts_borrowing_company": string;
	"movement.ts_commodity": string;
	"movement.ts_movement_id": string;
	"movement.unlock_time": Date;
	"movement.waterfall_flood_time": Date;
	"movement.waterfall_in_progress": string;
	"movement.xfer2settle_date": Date;
	"movement.xferred2fueltax": string;
	"movement.xferred2fueltaxdt": Date;
	"movement.xmit_accepted": string;
	"movement.xmitted2driver": Date;
	"movement.zmit_trip": string;
	"movement_order.company_id": string;
	"movement_order.id": string;
	"movement_order.movement_id": string;
	"movement_order.on_at_move_dest": string;
	"movement_order.on_at_move_origin": string;
	"movement_order.order_id": string;
	"movement_order.planned_manifest_id": string;
	"movement_order.sequence": number;
	oil_hub: number;
	outservice_date: Date;
	owner: string;
	owner_id: string;
	pay_owner: string;
	"payee.ach_batch_class_code": string;
	"payee.add_fed_to_wh": number;
	"payee.add_fed_to_wh_c": string;
	"payee.add_fed_to_wh_d": Date;
	"payee.add_fed_to_wh_n": number;
	"payee.add_fed_to_wh_r": number;
	"payee.addl_st_to_whold": number;
	"payee.addl_st_to_whold_c": string;
	"payee.addl_st_to_whold_d": Date;
	"payee.addl_st_to_whold_n": number;
	"payee.addl_st_to_whold_r": number;
	"payee.address1": string;
	"payee.address2": string;
	"payee.adp_co_code": string;
	"payee.adp_e_no": string;
	"payee.birth_date": Date;
	"payee.check_address": string;
	"payee.check_address2": string;
	"payee.check_city": string;
	"payee.check_city_st_zip": string;
	"payee.check_date": Date;
	"payee.check_name": string;
	"payee.check_number": string;
	"payee.check_st": string;
	"payee.check_stub_comment": string;
	"payee.check_zip": string;
	"payee.city": string;
	"payee.city_tax_code": string;
	"payee.company_id": string;
	"payee.country_id": string;
	"payee.county_tax_code": string;
	"payee.currency": string;
	"payee.dependents": number;
	"payee.dependents_c": string;
	"payee.dependents_d": Date;
	"payee.dependents_n": number;
	"payee.dependents_r": number;
	"payee.disable_payroll_taxes": string;
	"payee.eft_first_name": string;
	"payee.eft_individual": string;
	"payee.eft_last_name": string;
	"payee.eft_middle_initial": string;
	"payee.email": string;
	"payee.email_summary": string;
	"payee.enable_carrier_app": string;
	"payee.exempt_from_fed": string;
	"payee.extra_withholdings": number;
	"payee.extra_withholdings_c": string;
	"payee.extra_withholdings_d": Date;
	"payee.extra_withholdings_n": number;
	"payee.extra_withholdings_r": number;
	"payee.fed_amt_to_whold": number;
	"payee.fed_amt_to_whold_c": string;
	"payee.fed_amt_to_whold_d": Date;
	"payee.fed_amt_to_whold_n": number;
	"payee.fed_amt_to_whold_r": number;
	"payee.fed_exemptions": number;
	"payee.fed_marital_status": string;
	"payee.freeze_pay": string;
	"payee.freight_matching_override": string;
	"payee.gp_exclude": string;
	"payee.gp_exported": Date;
	"payee.hire_date": Date;
	"payee.holiday_hours_pd": number;
	"payee.id": string;
	"payee.last_raise_date": Date;
	"payee.legal_name": string;
	"payee.load_booking_eligible": string;
	"payee.loadpay_contact_phone": string;
	"payee.multiple_jobs": string;
	"payee.name": string;
	"payee.non_office_emp": string;
	"payee.office_employee": string;
	"payee.other_deductions": number;
	"payee.other_deductions_c": string;
	"payee.other_deductions_d": Date;
	"payee.other_deductions_n": number;
	"payee.other_deductions_r": number;
	"payee.other_income": number;
	"payee.other_income_c": string;
	"payee.other_income_d": Date;
	"payee.other_income_n": number;
	"payee.other_income_r": number;
	"payee.overtime_hours_pd": number;
	"payee.payment_method": string;
	"payee.phone_number": string;
	"payee.posted_check_date": Date;
	"payee.prev_code": string;
	"payee.primary_agency": string;
	"payee.regular_hours_pd": number;
	"payee.remarks": string;
	"payee.settlement_status": string;
	"payee.sick_hours_pd": number;
	"payee.social_security_no": string;
	"payee.st_amt_to_whold": number;
	"payee.st_amt_to_whold_c": string;
	"payee.st_amt_to_whold_d": Date;
	"payee.st_amt_to_whold_n": number;
	"payee.st_amt_to_whold_r": number;
	"payee.st_marital_status": string;
	"payee.state": string;
	"payee.state_exemptions": number;
	"payee.state_tax_code": string;
	"payee.status": string;
	"payee.sui_tax_code": string;
	"payee.tax_table_city_aux": number;
	"payee.tax_table_city_misc": number;
	"payee.tax_table_county_aux": number;
	"payee.tax_table_county_misc": number;
	"payee.tax_table_fit_aux": number;
	"payee.tax_table_fit_misc": number;
	"payee.tax_table_st_aux": number;
	"payee.tax_table_st_misc": number;
	"payee.tax_table_sui_aux": number;
	"payee.tax_table_sui_misc": number;
	"payee.termination_date": Date;
	"payee.vacation_hours_pd": number;
	"payee.vm_part_update": string;
	"payee.w4_status": string;
	"payee.wf_queue": number;
	"payee.ytd_holiday_hrs": number;
	"payee.ytd_overtime_hrs": number;
	"payee.ytd_reg_hrs_paid": number;
	"payee.ytd_sick_hrs_paid": number;
	"payee.ytd_vacation_hrs": number;
	"payee.zip_code": string;
	phantom: string;
	planning_comment: string;
	pnn_avail_frm_city: string;
	pnn_avail_frm_st: string;
	pnn_avail_frm_zip: string;
	pnn_avail_to_city: string;
	pnn_avail_to_st: string;
	pnn_avail_to_type: string;
	pnn_comment: string;
	pnn_comment2: string;
	pnn_cubicfeet: number;
	pnn_decklength: number;
	pnn_enhancements: string;
	pnn_loadweight: number;
	pnn_ovr_callback: string;
	pnn_post_type: string;
	posted_stop_id: string;
	primary_agency: string;
	promise_date: Date;
	purchase_date: Date;
	pwu_uid: number;
	serial_number: string;
	service_status: string;
	status: string;
	swap: string;
	tag: string;
	tag_expire_date: Date;
	tag_state: string;
	"team_driver.ace_id": string;
	"team_driver.address": string;
	"team_driver.alert": string;
	"team_driver.allow_trailer_drop": string;
	"team_driver.avl_as_of_date": Date;
	"team_driver.avl_drive_hours": number;
	"team_driver.avl_hours": number;
	"team_driver.avl_onduty_hours": number;
	"team_driver.base_term1": string;
	"team_driver.base_term2": string;
	"team_driver.base_zip1": string;
	"team_driver.base_zip2": string;
	"team_driver.birth_date": Date;
	"team_driver.bseg": string;
	"team_driver.can_rehire": string;
	"team_driver.capcreat_filter": string;
	"team_driver.cb": string;
	"team_driver.cell_phone": string;
	"team_driver.chain_pref_1": string;
	"team_driver.chain_pref_1_value": number;
	"team_driver.chain_pref_2": string;
	"team_driver.chain_pref_2_value": number;
	"team_driver.choice_allocation": string;
	"team_driver.choice_commodity": string;
	"team_driver.choice_commodity_exclude": string;
	"team_driver.choice_customer": string;
	"team_driver.choice_equip_type": string;
	"team_driver.choice_exclude_hazmat": string;
	"team_driver.choice_order_type": string;
	"team_driver.choice_priority1": string;
	"team_driver.choice_priority1_value": number;
	"team_driver.choice_priority2": string;
	"team_driver.choice_priority2_value": number;
	"team_driver.choice_revenue": string;
	"team_driver.choice_review_dt": Date;
	"team_driver.citizen": string;
	"team_driver.citizen_country": string;
	"team_driver.city": string;
	"team_driver.city_id": number;
	"team_driver.cmove": string;
	"team_driver.company_id": string;
	"team_driver.country_hos_rules": string;
	"team_driver.country_id": string;
	"team_driver.currenteqpgrpid": string;
	"team_driver.ded_rqmt_type": string;
	"team_driver.ded_type": string;
	"team_driver.disable_driver_choice": string;
	"team_driver.disable_feasibility": string;
	"team_driver.disable_remote_access": string;
	"team_driver.doubles_certified": string;
	"team_driver.dri_uid": number;
	"team_driver.drvr_class": string;
	"team_driver.ds_model_flag": string;
	"team_driver.eld_exempt_reason_id": string;
	"team_driver.email": string;
	"team_driver.emrg_response_date": Date;
	"team_driver.enable_driver_app": string;
	"team_driver.enable_load_choice": string;
	"team_driver.end_status_date": Date;
	"team_driver.enginedata_pwd": string;
	"team_driver.equipment_type_id": string;
	"team_driver.event_date": Date;
	"team_driver.event_status": string;
	"team_driver.exclude_allocation": string;
	"team_driver.exclude_commodity": string;
	"team_driver.exclude_customer": string;
	"team_driver.exclude_equip_type": string;
	"team_driver.exclude_feasibility": string;
	"team_driver.exclude_order_type": string;
	"team_driver.exclude_revenue": string;
	"team_driver.experience": string;
	"team_driver.first_name": string;
	"team_driver.fleet_manager": string;
	"team_driver.fmcsa_clearinghouse_date": Date;
	"team_driver.group_id": string;
	"team_driver.hazmat_certified": string;
	"team_driver.hazmat_date": Date;
	"team_driver.hire_date": Date;
	"team_driver.hm126c_date": Date;
	"team_driver.home_duration": number;
	"team_driver.home_location_id": string;
	"team_driver.id": string;
	"team_driver.is_active": string;
	"team_driver.last_34_hour_start_date": Date;
	"team_driver.last_break_date": Date;
	"team_driver.last_home_date": Date;
	"team_driver.last_review_date": Date;
	"team_driver.latitude": number;
	"team_driver.license_country": string;
	"team_driver.license_date": Date;
	"team_driver.license_no": string;
	"team_driver.license_state": string;
	"team_driver.logbook_required": string;
	"team_driver.longitude": number;
	"team_driver.manual_pta_update": string;
	"team_driver.maryland_perm_date": Date;
	"team_driver.max_dispatches": number;
	"team_driver.max_dist_loc1": number;
	"team_driver.max_dist_loc2": number;
	"team_driver.max_mi_per_day": number;
	"team_driver.mc_login": string;
	"team_driver.mc_unit_password": string;
	"team_driver.medical_cert_exempt": string;
	"team_driver.medical_cert_expire": Date;
	"team_driver.model_flag": string;
	"team_driver.mpw_driver_contact_method": string;
	"team_driver.mpw_driver_high": number;
	"team_driver.mpw_driver_low": number;
	"team_driver.mpw_exclude": string;
	"team_driver.mpw_last_contact": Date;
	"team_driver.mpw_num_attempts": number;
	"team_driver.mpw_num_orders": number;
	"team_driver.mvr_date": Date;
	"team_driver.name": string;
	"team_driver.name_mid_initial": string;
	"team_driver.name_of_spouse": string;
	"team_driver.next_home_date": Date;
	"team_driver.num_complaints": number;
	"team_driver.pager": string;
	"team_driver.passport": string;
	"team_driver.payee_id": string;
	"team_driver.personal_conveyance": string;
	"team_driver.phone": string;
	"team_driver.physical_date": Date;
	"team_driver.planning_comment": string;
	"team_driver.preferred_days_out": number;
	"team_driver.prev_code": string;
	"team_driver.primary_agency": string;
	"team_driver.proximity_card": string;
	"team_driver.pta_date": Date;
	"team_driver.race": string;
	"team_driver.reason_for_leaving": string;
	"team_driver.record_pta": string;
	"team_driver.remark": string;
	"team_driver.reporting_status": string;
	"team_driver.return_home_flag": string;
	"team_driver.route_through_term": string;
	"team_driver.safety_meet_date": Date;
	"team_driver.safety_topic": string;
	"team_driver.security_date": Date;
	"team_driver.sex": string;
	"team_driver.shuttle_capable": string;
	"team_driver.site_id": string;
	"team_driver.social_security_no": string;
	"team_driver.speed": number;
	"team_driver.start_status_date": Date;
	"team_driver.state": string;
	"team_driver.status_code": string;
	"team_driver.stop_pta_update": string;
	"team_driver.tanks_endorsement": string;
	"team_driver.team_status": string;
	"team_driver.tenstreet_id": string;
	"team_driver.termination_date": Date;
	"team_driver.tractor_id": string;
	"team_driver.trainee": string;
	"team_driver.type_of": string;
	"team_driver.violation_comment": string;
	"team_driver.yard_move": string;
	"team_driver.zip": string;
	"tractor_item.company_id": string;
	"tractor_item.equipment_group_id": string;
	"tractor_item.equipment_id": string;
	"tractor_item.equipment_type_id": string;
	"tractor_item.id": string;
	"tractor_item.trailer_dropped": string;
	"tractor_item.type_sequence": number;
	"trailer.ace_id": string;
	"trailer.axles": number;
	"trailer.borrow_request_datetime": Date;
	"trailer.borrower_user_id": string;
	"trailer.company_id": string;
	"trailer.compartments": string;
	"trailer.currenteqpgrpid": string;
	"trailer.disconnect_date": Date;
	"trailer.disposition_code": string;
	"trailer.dollar_value": number;
	"trailer.dollar_value_c": string;
	"trailer.dollar_value_d": Date;
	"trailer.dollar_value_n": number;
	"trailer.dollar_value_r": number;
	"trailer.door_height": number;
	"trailer.door_height_um": string;
	"trailer.door_type_code": string;
	"trailer.empty": string;
	"trailer.features": string;
	"trailer.floor_space": number;
	"trailer.fuel_level": number;
	"trailer.gross_veh_weight": number;
	"trailer.gross_veh_weight_um": string;
	"trailer.heater_code": string;
	"trailer.height": number;
	"trailer.height_um": string;
	"trailer.id": string;
	"trailer.inservice_date": Date;
	"trailer.inspection_date": Date;
	"trailer.is_active": string;
	"trailer.is_hooked": string;
	"trailer.last_emptied": Date;
	"trailer.length_of": number;
	"trailer.length_of_um": string;
	"trailer.license_country": string;
	"trailer.license_no": string;
	"trailer.license_state": string;
	"trailer.liftgate_code": string;
	"trailer.loan_availability_status": string;
	"trailer.loan_status": string;
	"trailer.maintenance_date": Date;
	"trailer.make": string;
	"trailer.max_temp": number;
	"trailer.message_send_date": Date;
	"trailer.min_temp": number;
	"trailer.model_year": string;
	"trailer.multi_placard_code": string;
	"trailer.odometer": number;
	"trailer.odometer_update_date": Date;
	"trailer.on_loan_from": string;
	"trailer.on_loan_to": string;
	"trailer.outservice_date": Date;
	"trailer.owner": string;
	"trailer.ownership": string;
	"trailer.pallets": number;
	"trailer.physical_trailer_id": string;
	"trailer.planning_comment": string;
	"trailer.plc_uid": number;
	"trailer.primary_agency": string;
	"trailer.promise_date": Date;
	"trailer.purchase_date": Date;
	"trailer.ramp_code": string;
	"trailer.reefer_id": string;
	"trailer.remarks": string;
	"trailer.securement_code": string;
	"trailer.serial_number": string;
	"trailer.statuscode": string;
	"trailer.tag_expire_date": Date;
	"trailer.tractor_id": string;
	"trailer.trailer_battery_status": string;
	"trailer.trailer_group": string;
	"trailer.trailer_type": string;
	"trailer.trl_uid": number;
	"trailer.ts_inprogress": string;
	"trailer.type_ace": string;
	"trailer.type_of": string;
	"trailer.volume": number;
	"trailer.volume_um": string;
	"trailer.weight": number;
	"trailer.weight_um": string;
	"trailer.width": number;
	"trailer.width_um": string;
	"trailer.work_order": string;
	"trailer.work_order_status": string;
	"trailer_item.company_id": string;
	"trailer_item.equipment_group_id": string;
	"trailer_item.equipment_id": string;
	"trailer_item.equipment_type_id": string;
	"trailer_item.id": string;
	"trailer_item.trailer_dropped": string;
	"trailer_item.type_sequence": number;
	transponder: string;
	type_of: string;
	"users.acct_lock_date": Date;
	"users.active_date": Date;
	"users.admin_user": string;
	"users.agent": string;
	"users.agree_fieldmarshal": Date;
	"users.agree_tailor": Date;
	"users.agree_tailor_ext": Date;
	"users.all_contacts": string;
	"users.allow_new_devices": string;
	"users.alternative_user": string;
	"users.ap_division_id": string;
	"users.appt_sched_id": string;
	"users.auth_subject": string;
	"users.auto_edit_type": string;
	"users.avail_tract_path": string;
	"users.avail_tract_sample": string;
	"users.available": string;
	"users.bridge_customer_access": string;
	"users.brokerage_divider": number;
	"users.brokerage_planning": string;
	"users.brokerage_planning2": string;
	"users.brokerage_planning3": string;
	"users.brokerage_planning4": string;
	"users.brokerage_planning_contnr": string;
	"users.call_list_profile": string;
	"users.carrier_call_list_id": string;
	"users.carrier_mgr_profil": string;
	"users.carrier_mgr_profil2": string;
	"users.carrier_mgr_profil3": string;
	"users.carrier_mgr_profil4": string;
	"users.cell_phone": string;
	"users.close_window": string;
	"users.commission_payee_id": string;
	"users.company_id": string;
	"users.company_name": string;
	"users.conf_cntr_template": number;
	"users.conf_template": number;
	"users.confirm_record": string;
	"users.contact_id": string;
	"users.continuous_radius": number;
	"users.crm_vs_profile": string;
	"users.csm_profile_id": string;
	"users.csm_profile_id2": string;
	"users.csm_profile_id3": string;
	"users.csm_profile_id4": string;
	"users.currency_reporting": string;
	"users.currency_transaction": string;
	"users.daily_advance_limits": string;
	"users.daily_brok_profile": string;
	"users.daily_snap_profile": string;
	"users.date_format": string;
	"users.default_search": number;
	"users.default_wirecode": string;
	"users.delivered_load_day": number;
	"users.department_id": string;
	"users.detention_profile_id": string;
	"users.detention_profile_id2": string;
	"users.detention_profile_id3": string;
	"users.detention_profile_id4": string;
	"users.disp_new_order_screen": string;
	"users.distance_calc_vendor": string;
	"users.dock_enable_wfmd_mode_swtch": string;
	"users.dock_login_id": string;
	"users.dragndrop_profile_id": string;
	"users.driver_manager_profile": string;
	"users.driver_manager_profile2": string;
	"users.driver_manager_profile3": string;
	"users.driver_manager_profile4": string;
	"users.driver_manager_vendor": string;
	"users.driver_managers": string;
	"users.drivers_wo_manager": string;
	"users.ds_cap_profile": string;
	"users.ds_mv_eta_profile": string;
	"users.ds_mv_eval_profile": string;
	"users.dsp_override_user": string;
	"users.email_address": string;
	"users.email_bcc": string;
	"users.email_client": string;
	"users.email_host": string;
	"users.email_imap_host": string;
	"users.email_imap_password": string;
	"users.email_imap_sent_folder": string;
	"users.email_imap_ssl": string;
	"users.email_imap_username": string;
	"users.email_override_company": string;
	"users.email_password": string;
	"users.email_port": number;
	"users.email_protocol": string;
	"users.email_use_sent_folder": string;
	"users.email_username": string;
	"users.employee_type": string;
	"users.enable_alerts": string;
	"users.extension": string;
	"users.external_password": string;
	"users.external_user_id": string;
	"users.failed_logins": number;
	"users.fax": string;
	"users.fileimport_profile": string;
	"users.findnear_vendor": string;
	"users.fleetmgmt_prof_id": string;
	"users.fm_account_id": string;
	"users.fm_can_view_metadata": string;
	"users.fm_profile_id": string;
	"users.fm_webhook_url": string;
	"users.google_map_layer": string;
	"users.google_map_type": string;
	"users.grid_even_row_color": number;
	"users.grid_insert_sort": string;
	"users.grid_odd_row_color": number;
	"users.id": string;
	"users.img_category": string;
	"users.inactive_date": Date;
	"users.is_active": string;
	"users.is_clearer": string;
	"users.is_closer": string;
	"users.is_dock_supervisor": string;
	"users.is_dock_worker": string;
	"users.is_email_confirmed": string;
	"users.is_mcleod": string;
	"users.issue_atm_cash": string;
	"users.lock_status": string;
	"users.log_sql": string;
	"users.login_id": string;
	"users.ltl_carrier_brk_status": string;
	"users.ltl_mapping_vendor": string;
	"users.ltl_quote_template": number;
	"users.manifest_profile": string;
	"users.margin_percentage": number;
	"users.max_payment_code_amt": number;
	"users.max_payment_code_amt_c": string;
	"users.max_payment_code_amt_d": Date;
	"users.max_payment_code_amt_n": number;
	"users.max_payment_code_amt_r": number;
	"users.mc_position_vendor": string;
	"users.menu_tree_view": string;
	"users.mfa_device_id": string;
	"users.mfa_last_prompted": Date;
	"users.mfa_secret": string;
	"users.mfa_status": string;
	"users.mobcomm_profile_id": string;
	"users.mobile_pw_reset_token": string;
	"users.mobile_pw_token_expire_ms": number;
	"users.move_dates": string;
	"users.movement_map_vendor": string;
	"users.name": string;
	"users.notification": string;
	"users.notify_alerts": string;
	"users.notify_frequency": string;
	"users.notify_method": string;
	"users.notify_occurance": string;
	"users.operations_user_id": string;
	"users.order_mode": string;
	"users.order_planning2": string;
	"users.order_planning3": string;
	"users.order_planning4": string;
	"users.order_planning_vendor": string;
	"users.order_tran_request": string;
	"users.orderhist_profile": string;
	"users.outbound_notification": string;
	"users.override_vendor_division": string;
	"users.payee_id": string;
	"users.pbw_brokerage_planning": string;
	"users.phone": string;
	"users.planner": string;
	"users.planning": string;
	"users.planning_container": string;
	"users.planning_divider": number;
	"users.primary_agency": string;
	"users.prompt_cont_moves": string;
	"users.quote_comp_act_create": string;
	"users.quote_comp_act_id": string;
	"users.quote_pend_act_create": string;
	"users.quote_pend_act_id": string;
	"users.quote_template": number;
	"users.rapid_alert_expand": string;
	"users.rapid_alert_sound": string;
	"users.receive_alerts": string;
	"users.recruiting_profile": string;
	"users.request_location_vendor": string;
	"users.revenue_code_id": string;
	"users.route_detail_vendor": string;
	"users.save_screen_sizes": string;
	"users.search_history_limit": number;
	"users.sec_ans1": string;
	"users.sec_ans2": string;
	"users.sec_question1": number;
	"users.sec_question2": number;
	"users.seg_alloc_code": string;
	"users.sel_text_on_focus": string;
	"users.show_active": string;
	"users.show_google_route": string;
	"users.show_inactive": string;
	"users.single_point_vendor": string;
	"users.support_inactivate_date": Date;
	"users.system_tray": string;
	"users.telephony_number": string;
	"users.telephony_password": string;
	"users.terminal_id": string;
	"users.time_format": string;
	"users.token_key": number;
	"users.toolbar_multi_rows": string;
	"users.toolbar_setting": string;
	"users.trailer_loan_profile_id": string;
	"users.trailer_wash_loc": string;
	"users.trailer_wash_user": string;
	"users.trimble_map_traffic": string;
	"users.tw_seg_code": string;
	"users.tw_ticket_template": number;
	"users.type_agents": string;
	"users.type_carrier": string;
	"users.type_company_drs": string;
	"users.type_number": string;
	"users.type_owner_oper": string;
	"users.user_group": string;
	"users.vendor_user_id": string;
	"users.view_movement_vendor": string;
	"users.waterfall_default_rt_guide": string;
	"users.waterfall_include_rates": string;
	"users.waterfall_include_rt_guides": string;
	"users.waterfall_prevent_tendering": string;
	"users.web_acct_status": string;
	"users.web_agent": string;
	"users.web_created_on": Date;
	"users.web_enabled_on": Date;
	"users.web_last_login": Date;
	"users.web_locked_on": Date;
	"users.web_map": string;
	"users.web_password": string;
	"users.web_user_id": string;
	"users.web_user_type": string;
	"users.window_location": string;
	"users.windows_login": string;
	"users.wire_trans_per_day": number;
	"users.zone_mapping_vendor": string;
	video_safety_control_id: string;
	weight: number;
	weight_reg_code: string;
	weight_um: string;
	work_order: string;
	work_order_status: string;
	zmit_fuelopt: string;
}

